import React, {useContext} from 'react'
import FormLogin from "./views/FormLoginHT";
import Home from "./views/Home";
import './i18n'; // Importa la configuración de i18n
 
function App() {

        return (
            !sessionStorage.getItem('idusuario')?<FormLogin/>:<Home/>
        );
    }

    export default App;
